import PlayFromRecent from "./PlayFromRecent";
import { decodeHtmlEntities } from "constant/htmlEntities";
import SubCribeButton from "./SubCribeButton";
import { useSelector } from "react-redux";

function OpenEpisodeLeftSection({
  artwork_url,
  title,
  description,
  noOfEpisodes,
  episodes,
  podcastId,
  podcast,
}: any) {
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);

  return (
    <div className="mb-4 w-full cursor-default px-2 lg:sticky lg:top-24">
      {/* artwork */}
      <div className="flex w-full justify-center">
        <div className="relative h-[220px] w-[220px] overflow-hidden rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.6)] ring-1 ring-white/10 max-sm:h-[180px] max-sm:w-[180px]">
          {artwork_url && (
            <img
              src={artwork_url}
              alt="podcast icon"
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover"
            />
          )}
        </div>
      </div>

      {/* details */}
      <div className="mt-6 text-center">
        <h1 className="mx-auto max-w-md font-fredoka text-[32px] font-[700] leading-tight text-white max-sm:text-[26px]">
          {title}
        </h1>

        <p className="mx-auto mt-3 line-clamp-4 max-w-md text-[13px] font-[400] leading-relaxed text-[#7B9DB4]">
          {decodeHtmlEntities(description)}
        </p>

        <div className="mt-4 flex justify-center">
          <span className="inline-flex items-center rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[12px] font-[700] text-[#7B9DB4]">
            {noOfEpisodes} Available episodes
          </span>
        </div>

        <div className="mt-6 flex justify-center">
          <PlayFromRecent episodes={episodes} />
        </div>

        {/* {loggedInUser && <SubCribeButton podcast={podcast} />} */}
      </div>
    </div>
  );
}

export default OpenEpisodeLeftSection;